export default __webpack_public_path__ + "static/9-0107bcb22a351421895a5f8ef2c1974d.jpg";